import React, { useState, forwardRef } from 'react';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles.css"

const Faqs = forwardRef((props, ref) => {
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section ref={ref} className='faqsmargin'>
            <h2 className="missonHeading">FAQs</h2>
            <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                    <AccordionHeader targetId="1">What is the duration of Internship?
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                        All our internships are for a period of 1 month only.
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="2">Can I complete multiple tracks together?
                    </AccordionHeader>
                    <AccordionBody accordionId="2">
                        We believe to provide an actual learning environment, we have limited our internship offerings to 1 track per month for each student. This allows students to explore the choosen track in-depth and get quality results.
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="3">Is there any fees for the internship?
                    </AccordionHeader>
                    <AccordionBody accordionId="3">
                        The internship is completely free. However certification fees of ₹99 has to be paid to cover the documentation expenses.
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="4">When will I receive the Offer Letter?
                    </AccordionHeader>
                    <AccordionBody accordionId="4">
                        We process the Offer Letters at the mid & end of month in batches. We request you to please wait in the mean time.

                        If you have received the Task Submission Email, we request you to review your spam folder for the Offer Letter. Kindly contact us via email if you are unable to find it.                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="5">What is the criteria for selection?
                    </AccordionHeader>
                    <AccordionBody accordionId="5">
                        Determination to learn and grow is all what is needed.
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="6">When does the internships starts?
                    </AccordionHeader>
                    <AccordionBody accordionId="6">
                        Each batch starts at the start or mid of the month and ends on start or mid of next month respectively.
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId="7">Is the internship Offline or Online?
                    </AccordionHeader>
                    <AccordionBody accordionId="7">
                        All our internships are conducted in Virtual mode (Online).                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </section>
    );
})

export default Faqs;